// Build-time environment variables. Do not edit; these variables are defined in
// the root .env files. For constants, use @shared/styles/constants

const VERSION = import.meta.env.VITE_VERSION;
const GIT_COMMIT = import.meta.env.VITE_GIT_COMMIT;

// log version to production console for release testing and debugging
if (import.meta.env.PROD) {
  console.log(`Coast v${VERSION}`);
}

export const Config = {
  VERSION,
  GIT_COMMIT,
  VERSION_STRING: `v${VERSION} (${GIT_COMMIT})`,
  BUILDER_APP_URL: getBuilderAppUrl(),
};

function getBuilderAppUrl() {
  const isE2ETest = 'Cypress' in window;
  const isProduction = import.meta.env.PROD;
  if (isE2ETest && !isProduction) {
    return 'https://staging.coastapp.com/builder';
  } else {
    return import.meta.env.VITE_BUILDER_APP_URL ?? '';
  }
}
